import React from 'react'
import Contact from '../components/contact';
import Contactcard from '../components/contactcard';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';

const ContactUs = () => {
    useDocumentTitle("Contactenos");
    return (
        <div>
            <PageHeader tittle="CONTÁCTENOS" />
            <div className='flex flex-col items-center mb-8 mt-8 w-full'>
                
                <Contact />
                <Contactcard />

            </div>

        </div>
    );
}

export default ContactUs
